<template lang="pug">
  div
    .step-content
      .shop-form
        slot
            // center
              img(src="@/assets/activity.png" style="width:95%")
            el-col(type="flex" justify="center" align="middle")  請選擇寄件/收件方式：
              el-select(v-model="shippingMethod__" style="width:280px;" @change="$emit('setShippingMethod', shippingMethod__)")
                el-option(
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled")
            .method(v-if="shippingMethod__ === 1")
              el-col(:span="24" type="flex" justify="center" align="middle").demo-image 
                a(href="https://ezwash.tw/?page_id=1460" target="_blank")
                  i(class="el-icon-info el-icon--left") 到府服務-收送說明
                // span.block
                  img(src="@/assets/s1.png" class="col2-img")
                  img(src="@/assets/s2.png" class="col2-img")
                  img(src="@/assets/s3.png" class="col2-img")
                  img(src="@/assets/s4.png" class="col2-img")
              // el-card.box-card(style="background-color: gainsboro;")
                p 我們的服務流程很簡單
                ol
                li 我們會在約定的時間派服務員到達約定的地點收件
                li 我們的服務員會帶我們的裝衣袋過去給您當場裝袋, 如果您的衣服較多您也可以先用自己的袋子把衣服裝好, 我們的服務員直接帶走
                li 收回來後我們會進行估價, 並報價給您, 您同意後我們才清洗
                li 洗好後會跟您約時間送回到府上
                li 服務員會當場收取現金費用
                p 以上就是整個服務流程, 輕輕鬆鬆您就把洗衣搞定了
            .method(v-if="shippingMethod__ === 2") 
              el-col(:span="24" type="flex" justify="center" align="middle").demo-image
                a(href="https://ezwash.tw/?page_id=1463" target="_blank")
                  i(class="el-icon-info el-icon--left") 掌櫃服務-寄送說明
                
              // el-col(:span="24" type="flex" justify="center" align="middle").demo-image
                  img(src="@/assets/1.png" class="col2-img")
              
                  img(src="@/assets/2.png" class="col2-img")
              
                  img(src="@/assets/3.png" class="col2-img")
              
                  img(src="@/assets/4.png" class="col2-img")
              
                  img(src="@/assets/5.png" class="col2-img")
              
                  img(src="@/assets/6.png" class="col2-img")
              
                  img(src="@/assets/7.png" class="col2-img")
          
    .cart__footer(class="new-footer")
      el-col(:span="8")
      el-col.text-center(:span="8" style="padding: 0px;")
        router-link(:to={name:'detail'})
          el-button(type="primary" style="float:center;" @click="$emit('setStep',1)" :disabled='disabled' class="black-button") 下一步

      el-col(:span="8")
</template>

<script>
import InfoItem from './InfoItem'

import Cookies from 'js-cookie'
import { getUserInfo } from '@/api/user'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'CartInfo',
  props: {
    shippingMethod: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      options: [{
        value: 1,
        label: '到府收送'
      }, {
        value: 2,
        label: '掌櫃全台寄件（停止服務）',
        disabled: true
      }],
      shippingMethod__: this.shippingMethod,
      fits: ['@/assets/s1.png', '@/assets/s1.png', '@/assets/s1.png', '@/assets/s1.png', '@/assets/s1.png'],
      url: 'https://lh3.googleusercontent.com/ELuC9hbi9IAw59rZ0FoVtVKxPNoarwJziwsmqbloj4lE8iOQ4xA0_vpIXNQF9QPuSplxB2j6IfEky6vxAASkj_c-nlsfeABjaot6gOBWcUgeIH5KEK5xLyvtpdtJNlcSSSkV_Kw14FE',
      address: ''


    }
  },
  computed: {
    ...mapState('cart', ['cart']),
    ...mapGetters('cart', ['classifiedData', 'total', 'itemInCart']),
    disabled () {
      return !true
    },
    priceFormat: function () {
      return (this.total || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    }
  },
  components: {
    InfoItem
  },
  created() {
    this.$emit('setStep', 0)
    let userTel = Cookies.get('phone');
      getUserInfo({userTel: userTel}).then(res=>{
        console.log(res)
        this.address = res.data.address
        console.log( this.shippingMethod__)
        this.$emit('setUserLv', res.data.lv)
      })
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'bestChoiceLookmore' })
    }
  }
}
</script>
<style lang="scss" scoped>
// .main {
  // margin-top: 80px;
// }
.cart {
  &__footer {
    // background: white;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    // position: fixed;
    bottom: 0;
    border-top: 1px solid #ccc;
    z-index: 99;
    height: 60px;
    width: 100vw;
    margin-left: -20px;
    margin-bottom: -20px;
    padding: 0 20px;
    font-size: 1.25em;
    .el-button {
      width: 30vw;
    }
  }
}
.empty {
  text-align: center;
  h1 {
    color: #646464;
  }
  button {
    position: absolute;
    top: 50vh;
    width: 30vw;
    left: 50%;
    transform: translateX(-50%);
  }
}
.shopName {
  margin-top: 10px;
  margin-bottom: 10px;
  color: #ee4d2d;
}
.method {
  padding-top: 90px;
}

img.col2-img {
  width: 80%;
  padding: 5px;
}
@media (min-width: 800px) {

 img.col2-img {
    width: 50%;
    padding: 5px;
  }
   .cart__footer {
    width: 75vw;
  }
}
// @media (min-width: 1000px) {

//  img.col2-img {
//     width: 35%;
//     padding: 5px;
//   }
//   .cart__footer {
//     width: 65vw;
//   }
// }
</style>
